import React from "react";
import { Modal, Col, Row } from "antd";
import { forEachObjIndexed } from "ramda";

export default error => {
  if (error) {
    if (typeof error === "string") {
      return Modal.error({ title: "Validation error", content: error });
    }
    let errors = [];
    if (Array.isArray(error)) {
      errors = error;
    } else {
      forEachObjIndexed((value, key) => {
        errors = errors.concat(value.errors);
      }, error);
    }
    return Modal.error({
      title: "Validation error",
      content: (
        <Col>
          {errors.map((error, index) => {
            return <Row key={`validation_error_${index}`}>{error.message}</Row>;
          })}
        </Col>
      )
    });
  }
  return Modal.error({ title: "Validation error" });
};



// WEBPACK FOOTER //
// ./src/commonComponents/ModalValidationError.js